import type { MemberNodeProps } from '@commons/pagebuilder/nodes/Member';
import MemberNodeLabel from '@commons/pagebuilder/nodes/Member/Label';
import { DRUPAL_NODE_DISPLAY } from '@commons/types/drupal';

import MemberNodeCard from './Card';

/**
 * AiiA member node component.
 *
 * Reuses the shared member label display and overrides the card display for AiiA.
 */

const AiiAMemberNode = (props: MemberNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <MemberNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <MemberNodeCard {...props} />;
  }
};

export default AiiAMemberNode;
